// extracted by mini-css-extract-plugin
export var chartWrapper = "l_2";
export var loanCardListContainer = "l_0";
export var loanContainer = "l_X";
export var loanLimitDisclaimer = "l_1";
export var loanTableContainer = "l_Y";
export var newLoanOptionsContainer = "l_W";
export var titledListContainer = "l_Z";